import RpcClass from "../../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.dictionaries.TechnologicalDetails';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class TechnologicalDetails extends RpcClass{

    /**
     *  @class TechnologicalDetails
     *  @alias module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {LocalDate}  */
        this.actualDeliveryDateToWarehouse = null;
        /** @type {boolean}  */
        this.assignMaterialCompositionToOtherTechDetails = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.color = null;
        /** @type {string}  */
        this.colorVersionId = null;
        /** @type {string}  */
        this.colorVersionNumber = null;
        /** @type {string}  */
        this.commentOnTheOrder = null;
        /** @type {string}  */
        this.comments = null;
        /** @type {string}  */
        this.componentIndexId = null;
        /** @type {string}  */
        this.compositionId = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.dateOfOrder = null;
        /** @type {string}  */
        this.designerDescription = null;
        /** @type {string}  */
        this.estimatedDeliveryDateToWarehouse = null;
        /** @type {BigDecimal}  */
        this.fabricWearDecimal = null;
        /** @type {BigDecimal}  */
        this.fabricWidth = null;
        /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
        this.gallery = null;
        /** @type {string}  */
        this.grammage = null;
        /** @type {BigDecimal}  */
        this.height = null;
        /** @type {string}  */
        this.id = null;
        /** @type {BigDecimal}  */
        this.length = null;
        /** @type {boolean}  */
        this.mainColor = null;
        /** @type {string}  */
        this.material1 = null;
        /** @type {string}  */
        this.material2 = null;
        /** @type {string}  */
        this.material3 = null;
        /** @type {string}  */
        this.material4 = null;
        /** @type {string}  */
        this.material5 = null;
        /** @type {string}  */
        this.material6 = null;
        /** @type {string}  */
        this.notesForSupply = null;
        /** @type {string}  */
        this.orderDetailsId = null;
        /** @type {boolean}  */
        this.otherLabel = null;
        /** @type {string}  */
        this.pantoneColor = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.pricePerUnit = null;
        /** @type {string}  */
        this.productComponent = null;
        /** @type {string}  */
        this.productInSeasonId = null;
        /** @type {string}  */
        this.realizationStatusId = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.supplierId = null;
        /** @type {string}  */
        this.technologicalTypeId = null;
        /** @type {string}  */
        this.unitId = null;
        /** @type {BigDecimal}  */
        this.value1 = null;
        /** @type {BigDecimal}  */
        this.value2 = null;
        /** @type {BigDecimal}  */
        this.value3 = null;
        /** @type {BigDecimal}  */
        this.value4 = null;
        /** @type {BigDecimal}  */
        this.value5 = null;
        /** @type {BigDecimal}  */
        this.value6 = null;
        /** @type {number}  */
        this.version = null;
        /** @type {boolean}  */
        this.wcl = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }





    /** @type {string}  */
    get componentIndexIdCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['componentIndexIdCategory'] : null, this.__metadata__['componentIndexIdCategory']?.remoteType);
    }
    set componentIndexIdCategory(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getComponentIndexIdCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'componentIndexIdCategory',  allowRemote); //  false 
    }

    /** @returns {String} */
    getComponentIndexIdCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'componentIndexIdCategory'); //  false 
    }

    /** @returns {Promise<Category>} */
    getComponentIndexIdCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'componentIndexIdCategory',  allowRemote); //  false 
    }

    /** @type {boolean}  */
    get componentIndexIdCompleteTheComposition(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['componentIndexIdCompleteTheComposition'] : null, this.__metadata__['componentIndexIdCompleteTheComposition']?.remoteType);
    }
    set componentIndexIdCompleteTheComposition(val){
    }
    // fk: false

    /** @type {string}  */
    get componentIndexIdLocationInWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['componentIndexIdLocationInWarehouse'] : null, this.__metadata__['componentIndexIdLocationInWarehouse']?.remoteType);
    }
    set componentIndexIdLocationInWarehouse(val){
    }
    // fk: false

    /** @type {string}  */
    get componentIndexIdNotes(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['componentIndexIdNotes'] : null, this.__metadata__['componentIndexIdNotes']?.remoteType);
    }
    set componentIndexIdNotes(val){
    }
    // fk: false

    /** @type {string}  */
    get productComponentProductSpecification(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productComponentProductSpecification'] : null, this.__metadata__['productComponentProductSpecification']?.remoteType);
    }
    set productComponentProductSpecification(val){
    }
    // fk: false

    /** @type {string}  */
    get colorVersionIdStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['colorVersionIdStatus'] : null, this.__metadata__['colorVersionIdStatus']?.remoteType);
    }
    set colorVersionIdStatus(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getColorVersionIdStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ColorVersionStatus', 'colorVersionIdStatus',  allowRemote); //  false 
    }

    /** @returns {String} */
    getColorVersionIdStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ColorVersionStatus', 'colorVersionIdStatus'); //  false 
    }

    /** @returns {Promise<ColorVersionStatus>} */
    getColorVersionIdStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ColorVersionStatus', 'colorVersionIdStatus',  allowRemote); //  false 
    }

    /** @type {string}  */
    get supplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdSupplierCode'] : null, this.__metadata__['supplierIdSupplierCode']?.remoteType);
    }
    set supplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get componentIndexIdSupplierProductId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['componentIndexIdSupplierProductId'] : null, this.__metadata__['componentIndexIdSupplierProductId']?.remoteType);
    }
    set componentIndexIdSupplierProductId(val){
    }
    // fk: false

    /** @type {BigDecimal}  */
    get calculateTotalValuesOfFabrics(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['calculateTotalValuesOfFabrics'] : null, this.__metadata__['calculateTotalValuesOfFabrics']?.remoteType);
    }
    set calculateTotalValuesOfFabrics(val){
    }


    /** @type {BigDecimal}  */
    get fabricDemand(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['fabricDemand'] : null, this.__metadata__['fabricDemand']?.remoteType);
    }
    set fabricDemand(val){
    }


    /** @type {number}  */
    get numberOfOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['numberOfOrder'] : null, this.__metadata__['numberOfOrder']?.remoteType);
    }
    set numberOfOrder(val){
    }


    /** @type {number}  */
    get orderedQuantity(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderedQuantity'] : null, this.__metadata__['orderedQuantity']?.remoteType);
    }
    set orderedQuantity(val){
    }


    /** @type {string}  */
    get technologicalComponents(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['technologicalComponents'] : null, this.__metadata__['technologicalComponents']?.remoteType);
    }
    set technologicalComponents(val){
    }


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withActualDeliveryDateToWarehouse(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.actualDeliveryDateToWarehouse = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withAssignMaterialCompositionToOtherTechDetails(val){
        this.assignMaterialCompositionToOtherTechDetails = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withColor(val){
        this.color = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'color', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'color'); //  true 
    }

        /** @returns {Promise<Colors>} */
    getColorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'color', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withColorVersionId(val){
        this.colorVersionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorVersionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ColorVersion', 'colorVersionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorVersionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ColorVersion', 'colorVersionId'); //  true 
    }

        /** @returns {Promise<ColorVersion>} */
    getColorVersionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ColorVersion', 'colorVersionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withColorVersionNumber(val){
        this.colorVersionNumber = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withCommentOnTheOrder(val){
        this.commentOnTheOrder = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withComments(val){
        this.comments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withComponentIndexId(val){
        this.componentIndexId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getComponentIndexIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'componentIndexId', allowRemote); //  true 
    }

    /** @returns {String} */
        getComponentIndexIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'componentIndexId'); //  true 
    }

        /** @returns {Promise<ComponentIndex>} */
    getComponentIndexIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ComponentIndex', 'componentIndexId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withCompositionId(val){
        this.compositionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCompositionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'compositionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCompositionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'compositionId'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getCompositionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'compositionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withDateOfOrder(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateOfOrder = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withDesignerDescription(val){
        this.designerDescription = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withEstimatedDeliveryDateToWarehouse(val){
        this.estimatedDeliveryDateToWarehouse = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withFabricWearDecimal(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.fabricWearDecimal = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withFabricWidth(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.fabricWidth = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withGallery(val){
        this.gallery = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withGrammage(val){
        this.grammage = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withHeight(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.height = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withLength(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.length = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMainColor(val){
        this.mainColor = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMaterial1(val){
        this.material1 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial1Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material1', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial1StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material1'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial1Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material1', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMaterial2(val){
        this.material2 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial2Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material2', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial2StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material2'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial2Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material2', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMaterial3(val){
        this.material3 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial3Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material3', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial3StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material3'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial3Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material3', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMaterial4(val){
        this.material4 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial4Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material4', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial4StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material4'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial4Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material4', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMaterial5(val){
        this.material5 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial5Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material5', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial5StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material5'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial5Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material5', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withMaterial6(val){
        this.material6 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial6Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material6', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial6StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material6'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial6Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material6', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withNotesForSupply(val){
        this.notesForSupply = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withOrderDetailsId(val){
        this.orderDetailsId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getOrderDetailsIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.OrderDetails', 'orderDetailsId', allowRemote); //  true 
    }

    /** @returns {String} */
        getOrderDetailsIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.OrderDetails', 'orderDetailsId'); //  true 
    }

        /** @returns {Promise<OrderDetails>} */
    getOrderDetailsIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.OrderDetails', 'orderDetailsId', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withOtherLabel(val){
        this.otherLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withPantoneColor(val){
        this.pantoneColor = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withPricePerUnit(val){
        this.pricePerUnit = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withProductComponent(val){
        this.productComponent = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductComponentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TechnologicalProductComponent', 'productComponent', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductComponentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TechnologicalProductComponent', 'productComponent'); //  true 
    }

        /** @returns {Promise<TechnologicalProductComponent>} */
    getProductComponentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TechnologicalProductComponent', 'productComponent', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withProductInSeasonId(val){
        this.productInSeasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductInSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ProductInSeason', 'productInSeasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductInSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ProductInSeason', 'productInSeasonId'); //  true 
    }

        /** @returns {Promise<ProductInSeason>} */
    getProductInSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ProductInSeason', 'productInSeasonId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withRealizationStatusId(val){
        this.realizationStatusId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getRealizationStatusIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TechnologicalRealizationStatus', 'realizationStatusId', allowRemote); //  true 
    }

    /** @returns {String} */
        getRealizationStatusIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TechnologicalRealizationStatus', 'realizationStatusId'); //  true 
    }

        /** @returns {Promise<TechnologicalRealizationStatus>} */
    getRealizationStatusIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TechnologicalRealizationStatus', 'realizationStatusId', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withSupplierId(val){
        this.supplierId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierId'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withTechnologicalTypeId(val){
        this.technologicalTypeId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTechnologicalTypeIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TechnologicalProductType', 'technologicalTypeId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTechnologicalTypeIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TechnologicalProductType', 'technologicalTypeId'); //  true 
    }

        /** @returns {Promise<TechnologicalProductType>} */
    getTechnologicalTypeIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TechnologicalProductType', 'technologicalTypeId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withUnitId(val){
        this.unitId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getUnitIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Unit', 'unitId', allowRemote); //  true 
    }

    /** @returns {String} */
        getUnitIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Unit', 'unitId'); //  true 
    }

        /** @returns {Promise<Unit>} */
    getUnitIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Unit', 'unitId', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withValue1(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value1 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withValue2(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value2 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withValue3(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value3 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withValue4(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value4 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withValue5(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value5 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withValue6(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value6 = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withVersion(val){
        this.version = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails}
     */
    withWcl(val){
        this.wcl = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<TechnologicalDetails>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadTechnologicalDetails(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'componentIndexIdCategory'){
            return this.getComponentIndexIdCategoryLabel(allowRemote);
        }
        if(fiendName === 'colorVersionIdStatus'){
            return this.getColorVersionIdStatusLabel(allowRemote);
        }
        if(fiendName === 'color'){
            return this.getColorLabel(allowRemote);
        }
        if(fiendName === 'colorVersionId'){
            return this.getColorVersionIdLabel(allowRemote);
        }
        if(fiendName === 'componentIndexId'){
            return this.getComponentIndexIdLabel(allowRemote);
        }
        if(fiendName === 'compositionId'){
            return this.getCompositionIdLabel(allowRemote);
        }
        if(fiendName === 'material1'){
            return this.getMaterial1Label(allowRemote);
        }
        if(fiendName === 'material2'){
            return this.getMaterial2Label(allowRemote);
        }
        if(fiendName === 'material3'){
            return this.getMaterial3Label(allowRemote);
        }
        if(fiendName === 'material4'){
            return this.getMaterial4Label(allowRemote);
        }
        if(fiendName === 'material5'){
            return this.getMaterial5Label(allowRemote);
        }
        if(fiendName === 'material6'){
            return this.getMaterial6Label(allowRemote);
        }
        if(fiendName === 'orderDetailsId'){
            return this.getOrderDetailsIdLabel(allowRemote);
        }
        if(fiendName === 'productComponent'){
            return this.getProductComponentLabel(allowRemote);
        }
        if(fiendName === 'productInSeasonId'){
            return this.getProductInSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'realizationStatusId'){
            return this.getRealizationStatusIdLabel(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'technologicalTypeId'){
            return this.getTechnologicalTypeIdLabel(allowRemote);
        }
        if(fiendName === 'unitId'){
            return this.getUnitIdLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'color'){
            return this.getColorEntity(allowRemote);
        }
        if(fiendName === 'colorVersionId'){
            return this.getColorVersionIdEntity(allowRemote);
        }
        if(fiendName === 'componentIndexId'){
            return this.getComponentIndexIdEntity(allowRemote);
        }
        if(fiendName === 'compositionId'){
            return this.getCompositionIdEntity(allowRemote);
        }
        if(fiendName === 'material1'){
            return this.getMaterial1Entity(allowRemote);
        }
        if(fiendName === 'material2'){
            return this.getMaterial2Entity(allowRemote);
        }
        if(fiendName === 'material3'){
            return this.getMaterial3Entity(allowRemote);
        }
        if(fiendName === 'material4'){
            return this.getMaterial4Entity(allowRemote);
        }
        if(fiendName === 'material5'){
            return this.getMaterial5Entity(allowRemote);
        }
        if(fiendName === 'material6'){
            return this.getMaterial6Entity(allowRemote);
        }
        if(fiendName === 'orderDetailsId'){
            return this.getOrderDetailsIdEntity(allowRemote);
        }
        if(fiendName === 'productComponent'){
            return this.getProductComponentEntity(allowRemote);
        }
        if(fiendName === 'productInSeasonId'){
            return this.getProductInSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'realizationStatusId'){
            return this.getRealizationStatusIdEntity(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdEntity(allowRemote);
        }
        if(fiendName === 'technologicalTypeId'){
            return this.getTechnologicalTypeIdEntity(allowRemote);
        }
        if(fiendName === 'unitId'){
            return this.getUnitIdEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<TechnologicalDetails>}
 */
async function loadTechnologicalDetails(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<TechnologicalDetails[]>}
 */
async function listTechnologicalDetails(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelTechnologicalDetails(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<TechnologicalDetails>}
 */
TechnologicalDetails.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<TechnologicalDetails[]>}
 */
TechnologicalDetails.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<TechnologicalDetails[]>}
 */
TechnologicalDetails.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<TechnologicalDetails[]>}
 */
TechnologicalDetails.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<TechnologicalDetails>}
 */
TechnologicalDetails.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return TechnologicalDetails.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
TechnologicalDetails.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
TechnologicalDetails.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
TechnologicalDetails.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
TechnologicalDetails.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
TechnologicalDetails.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['actualDeliveryDateToWarehouse'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['assignMaterialCompositionToOtherTechDetails'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['color'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['commentOnTheOrder'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['comments'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['componentIndexId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['compositionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dateOfOrder'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['designerDescription'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['estimatedDeliveryDateToWarehouse'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fabricWearDecimal'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['fabricWidth'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['gallery'] = {'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['grammage'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['height'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['length'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['mainColor'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['material1'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material2'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material3'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material4'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material5'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material6'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['notesForSupply'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderDetailsId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['otherLabel'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['pantoneColor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pricePerUnit'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productComponent'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productInSeasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['realizationStatusId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['supplierId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['technologicalTypeId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['unitId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['value1'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value2'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value3'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value4'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value5'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value6'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['wcl'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['calculateTotalValuesOfFabrics'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['fabricDemand'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['numberOfOrder'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['orderedQuantity'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['technologicalComponents'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['componentIndexIdCategory'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['componentIndexIdCompleteTheComposition'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['componentIndexIdLocationInWarehouse'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['componentIndexIdNotes'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productComponentProductSpecification'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionIdStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['componentIndexIdSupplierProductId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.dictionaries.TechnologicalDetails';
metadata.__type_short__ = 'TechnologicalDetails';
TechnologicalDetails.prototype.__metadata__ = metadata;

TechnologicalDetails.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails */
export default TechnologicalDetails

export { TechnologicalDetails , loadTechnologicalDetails, listTechnologicalDetails, labelTechnologicalDetails }
